import React from 'react';

const TicketGrid = ({ tickets, onTicketClick, selectedTickets = [], isMultiSelectMode = false }) => {
  const getTicketColor = (ticket) => {
    // Debug para ver el estado del ticket
    if (ticket.reserved || ticket.sold) {
      console.log('Ticket', ticket.number, '- reserved:', ticket.reserved, 'sold:', ticket.sold);
    }
    
    if (ticket.sold) return 'bg-red-500 text-white cursor-not-allowed';
    if (ticket.reserved && !ticket.sold) return 'bg-yellow-400 text-gray-800 cursor-not-allowed border-2 border-yellow-500';
    
    // En modo multiselección, verificar si está seleccionado
    if (isMultiSelectMode && selectedTickets.find(t => t.id === ticket.id)) {
      return 'bg-purple-500 text-white cursor-pointer border-2 border-purple-600 ring-2 ring-purple-300';
    }
    
    return 'bg-white hover:bg-primary hover:text-white cursor-pointer border-2 border-gray-200';
  };

  const getTicketStatus = (ticket) => {
    if (ticket.sold) return 'Vendido';
    if (ticket.reserved) return 'Reservado';
    return 'Disponible';
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 md:p-6">
      <div className="ticket-grid">
        {tickets.map((ticket) => (
          <div
            key={ticket.id}
            onClick={() => onTicketClick(ticket)}
            className={`
              relative rounded-lg p-2 md:p-3 
              flex flex-col items-center justify-center
              transition-all duration-200 transform hover:scale-105
              ${ticket.displayNumbers && ticket.displayNumbers.includes('-') 
                ? 'min-h-[100px] md:min-h-[120px]' // Altura mínima para múltiples números
                : 'aspect-square'} // Mantener cuadrado para números únicos
              ${getTicketColor(ticket)}
            `}
            title={`Boleto #${ticket.number} - ${getTicketStatus(ticket)}`}
          >
            {/* Renderizar números con soporte para múltiples oportunidades */}
            {(() => {
              const numbers = ticket.displayNumbers || ticket.number.toString();
              const hasMultipleNumbers = numbers.toString().includes('-');
              
              // Log para debug
              if (hasMultipleNumbers && ticket.number <= 5) {
                console.log('Ticket con múltiples números:', ticket.number, 'displayNumbers:', numbers);
              }
              
              if (hasMultipleNumbers) {
                // Dividir los números y mostrarlos en líneas separadas
                const numberArray = numbers.toString().split('-');
                return (
                  <div className="ticket-numbers-vertical">
                    {numberArray.map((num, index) => (
                      <span key={index} className="text-sm md:text-base font-bold">
                        {num.trim()}
                      </span>
                    ))}
                  </div>
                );
              } else {
                // Mostrar número único normalmente
                return (
                  <span className="text-lg md:text-xl font-bold">
                    {numbers}
                  </span>
                );
              }
            })()}
            {ticket.displayNumbers && ticket.displayNumbers !== ticket.number.toString() && (
              <span className="text-xs mt-1 opacity-75">
                #{ticket.number}
              </span>
            )}
            
            {/* Signo de admiración para boletos reservados */}
            {ticket.reserved && !ticket.sold && (
              <span className="absolute top-0 left-0 bg-yellow-600 text-white rounded-tl-lg rounded-br-lg px-1 text-sm font-bold shadow-md">
                !
              </span>
            )}
            
            {/* Indicador de vendedor si existe */}
            {ticket.vendorName && (
              <span className="absolute top-1 right-1 text-xs opacity-50">
                {ticket.vendorName.charAt(0)}
              </span>
            )}
            
            {/* Indicador de selección en modo multiselección */}
            {isMultiSelectMode && selectedTickets.find(t => t.id === ticket.id) && (
              <span className="absolute bottom-1 right-1">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </span>
            )}
          </div>
        ))}
      </div>
      
      {tickets.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-500">No hay boletos para mostrar</p>
        </div>
      )}
    </div>
  );
};

export default TicketGrid;